import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { updateBrand } from "../../../services/admin/brand"; // Adjust path
import { getBrandById } from "../../../services/admin/brand"; // You need to define this

function AddAdminBrand() {
    const navigate = useNavigate();
    const { id } = useParams<{ id: string }>();

    const [formData, setFormData] = useState({
        name: "",
    });

    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (id) {
            (async () => {
                const res = await getBrandById(Number(id));
                if (res.success) {
                    setFormData({ name: res.data.name });
                } else {
                    console.error(res.error);
                }
            })();
        }
    }, [id]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();

        if (!id) return;

        setLoading(true);

        const res = await updateBrand(Number(id), formData);

        setLoading(false);

        if (res.success) {
            alert("Brand updated successfully");
            navigate("/admin/brand");
        } else {
            alert(res.error);
        }
    };

    return (
        <div className="p-6 space-y-6">
            {/* Header with back button */}
            <div className="flex items-center justify-between">
                <h1 className="text-2xl font-semibold text-gray-800">Edit Brand</h1>
                <button
                    onClick={() => navigate(-1)}
                    className="flex items-center text-sm text-gray-600 hover:text-[#009FE3] transition"
                >
                    <ArrowLeft className="w-4 h-4 mr-1" />
                    Back
                </button>
            </div>

            {/* Form */}
            <form onSubmit={handleSubmit} className="space-y-4 max-w-[600px]">
                {/* Name */}
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                        Brand Name
                    </label>
                    <input
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                        className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#009FE3]"
                    />
                </div>

                {/* Submit Button */}
                <button
                    type="submit"
                    disabled={loading}
                    className="w-full py-2 px-4 bg-[#009FE3] text-white rounded-lg hover:bg-[#008AC6] transition"
                >
                    {loading ? "Updating..." : "Update Brand"}
                </button>
            </form>
        </div>
    );
}

export default AddAdminBrand;
